export default "__VITE_ASSET__DRVV4nkP__"